import clsx from "clsx";
import { CheckIcon } from "@phosphor-icons/react";
import { Ref } from "react";

export function FormSuccessHeading({
	className,
	headingRef,
	title,
	description,
	onClose,
}: {
	className?: string;
	headingRef: Ref<HTMLHeadingElement>;
	title: string;
	description: string;
	onClose: () => void;
}) {
	return (
		<>
			<div className={clsx(className, "jF-relative jF-p-8")}>
				<div className="jF-mx-auto jF-flex jF-h-20 jF-w-20 jF-items-center jF-justify-center jF-rounded-full jF-bg-[--jF-bullet-bg]">
					<CheckIcon
						className="jF-h-10 jF-w-10 jF-text-[--jF-theme-color]"
						aria-hidden="true"
					/>
				</div>
				<div className="jF-mt-3 jF-text-center sm:jF-mt-5">
					<h3
						ref={headingRef}
						className="jF-text-[1.2rem] sm:jF-text-[1.5rem] lg:jF-text-[2rem] jF-mb-3 jF-font-semibold jF-leading-8 jF-text-[--jF-theme-h-text]"
					>
						{title}
					</h3>
					<div className="jF-mt-5 jF-mb-5">
						<p className="jF-text-md jF-text-gray-500 sm:jF-text-lg">{description}</p>
					</div>
					<div>
						<button
							type="button"
							className="jF-bg-[--jF-theme-color] hover:jF-bg-[--jF-hover-color] jF-cursor-pointer jF-text-white jF-text-md md:jF-text-lg jF-font-medium jF-px-4 jF-py-2 sm:jF-px-8 sm:jF-py-4 md:jF-py-2 jF-rounded-md jF-w-full md:jF-w-auto jF-transition-all"
							onClick={onClose}
						>
							Close
						</button>
					</div>
				</div>
			</div>
		</>
	);
}
